import React, { Fragment } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  BulkDeleteButton,
  SelectInput,
  BulkDeleteButtonProps,
  ListProps,
} from "react-admin";
import { Helmet } from "react-helmet";
import { statusList } from "./conts";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";

const BulkActionButtons = (props: BulkDeleteButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const PersonInChargeFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const PersonInChargeList = (props: ListProps) => {
  const PersonInChargeShowButton = (record: IParent) => {
    return (
      <Button href={`/#/personInCharges/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  const PersonInChargeEditButton = (record: IParent) => (
    <Button href={`/#/personInCharges/${record.id}`}>
      <EditIcon />
    </Button>
  );

  return (
    <>
      <Helmet>
        <title>Person In Charges Without Student</title>
      </Helmet>
      <List
        basePath="/personInCharges"
        resource="personInCharges"
        exporter={false}
        hasCreate={false}
        filters={<PersonInChargeFilter />}
        filter={{
          IsHaveStudent: false,
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={<BulkActionButtons />}
        {...props}
      >
        <Datagrid>
          <FunctionField
            label="Person In Charge Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Code :
                  </Typography>
                  <TextField source="id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <FunctionField
                    render={(record: any) =>
                      `${record.firstName} ${record.lastName}`
                    }
                  />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="mobile" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mbc Code :
                  </Typography>
                  <TextField source="user.mbcCustomerId" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Company Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Code :
                  </Typography>
                  <TextField source="company.id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <TextField source="company.name" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="company.user.email" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="company.mobile" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField source="createdAt" emptyText="-" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <PersonInChargeShowButton {...props} />
                <PersonInChargeEditButton {...props} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default PersonInChargeList;
